import "core-js/modules/web.dom.iterable";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import wishlistQuery from '~/graphql/wishlist/wishlist.gql';
import deleteWishlistItemMutation from '~/graphql/wishlist/deleteWishlistItem.gql';
import isValidToken from '~/helpers/connection-helper';

function fetchDetailedWishlist(_x, _x2, _x3) {
  return _fetchDetailedWishlist.apply(this, arguments);
}

function _fetchDetailedWishlist() {
  _fetchDetailedWishlist = _asyncToGenerator(function* (_ref, offset, limit) {
    let {
      app,
      getters
    } = _ref;

    if (isValidToken()) {
      const locale = getters['i18n/locale'].iso;
      const response = yield app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: wishlistQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale,
          detailed: true,
          offset,
          limit
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchDetailedWishlist.apply(this, arguments);
}

function fetchWishlist(_x4) {
  return _fetchWishlist.apply(this, arguments);
}

function _fetchWishlist() {
  _fetchWishlist = _asyncToGenerator(function* (context) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/moodboard/getDefaultWishList");
    const {
      data
    } = yield context.$axios.get(xhrUri, {
      withCredentials: true
    });
    return {
      product: !('product' in data.wishlist) ? [] : data.wishlist.product
    };
  });
  return _fetchWishlist.apply(this, arguments);
}

function getWishlist(_x5) {
  return _getWishlist.apply(this, arguments);
}

function _getWishlist() {
  _getWishlist = _asyncToGenerator(function* (context) {
    const data = yield fetchWishlist(context);
    return data;
  });
  return _getWishlist.apply(this, arguments);
}

function postItem(_x6, _x7) {
  return _postItem.apply(this, arguments);
}

function _postItem() {
  _postItem = _asyncToGenerator(function* (context, payload) {
    let strData = '';

    for (let i = 0; i < Object.entries(payload).length; i += 1) {
      if (strData) {
        strData += '&';
      }

      strData += "".concat(Object.entries(payload)[i][0], "=").concat(encodeURIComponent(Object.entries(payload)[i][1]));
    }

    const xhrUri = "".concat(context.state.sharedEnv.payload.web, "moodboard/default/items");
    const {
      data
    } = yield context.$axios(xhrUri, {
      method: 'POST',
      data: strData,
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    });
    return data;
  });
  return _postItem.apply(this, arguments);
}

function deleteItem(_x8, _x9) {
  return _deleteItem.apply(this, arguments);
}

function _deleteItem() {
  _deleteItem = _asyncToGenerator(function* (context, payload) {
    const xhrUri = "".concat(context.state.sharedEnv.payload.web, "moodboard/default/items/product/").concat(payload.reference);
    const {
      data
    } = yield context.$axios.delete(xhrUri, {
      emulateJSON: true
    });
    return data;
  });
  return _deleteItem.apply(this, arguments);
}

function deleteWishlistItem(_x10, _x11) {
  return _deleteWishlistItem.apply(this, arguments);
}

function _deleteWishlistItem() {
  _deleteWishlistItem = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteWishlistItemMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference
        }
      });
      return response.data;
    }

    return null;
  });
  return _deleteWishlistItem.apply(this, arguments);
}

export { getWishlist, postItem, deleteItem, deleteWishlistItem, fetchDetailedWishlist };